<template>
  <div id="app">
    <Navbar/>
    <router-view/>
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
// import Footer from '@/components/Footer.vue'
export default {

  name: "App",

  components: {
    Navbar,
    // Footer
  }
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  min-height: 75rem;
  /* padding-top: 0rem; */
}
</style>
